// extracted by mini-css-extract-plugin
export default {"root":"page_title___root___c84a041b","actions":"page_title___actions___f1eb02f3","children":"page_title___children___a14d3276","subtitle":"page_title___subtitle___f4ada855"};